import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const OtherNews = ({ themeColor, title, category, categoryLink, link }) => {
  // var themeBgColor = "text-fb-blue"
  var themeTextColor = "text-fb-blue"

  switch (themeColor) {
    case "fb-green": {
      // themeBgColor = "bg-fb-green"
      themeTextColor = "text-fb-green"
      break
    }
    case "fb-turquoise": {
      // themeBgColor = "bg-fb-turquoise"
      themeTextColor = "text-fb-turquoise"
      break
    }
    case "fb-gray": {
      // themeBgColor = "bg-fb-gray"
      themeTextColor = "text-fb-gray"
      break
    }
    case "fb-red": {
      // themeBgColor = "bg-fb-red"
      themeTextColor = "text-fb-red"
      break
    }
    case "fb-violet": {
      // themeBgColor = "bg-fb-violet"
      themeTextColor = "text-fb-violet"
      break
    }
    default: {
      // themeBgColor = "bg-fb-blue"
      themeTextColor = "text-fb-blue"
      break
    }
  }
  return (
    <div>
      <Link
        to={`/${categoryLink}/${link}`}
        activeClassName="inactive"
        className="font-opensanscond font-normal text-black text-sm"
      >
        {/* <div
          className={`${themeBgColor} px-5 py-3 bg-opacity-10 hover:bg-opacity-20`}
        > */}
        <div className="px-2 py-3 bg-fb-blue bg-opacity-0 hover:bg-opacity-5">
          <p
            className={`${themeTextColor} text-xl font-semibold font-opensanscond`}
          >
            {category}
          </p>

          <p className="font-roboto text-black truncate">{title}</p>
        </div>
      </Link>
    </div>
  )
}

OtherNews.prototype = {
  mainPicture: PropTypes.string,
  themeColor: PropTypes.string,
}
OtherNews.defaultProps = {
  mainPicture: `https://source.unsplash.com/random`,
  themeColor: `fb-blue`,
}

export default OtherNews
